export default __webpack_public_path__ + "static/media/login-ad.004ed702.png";